export const SET_PAYMENT_NOTIFICATION = 'SET_PAYMENT_NOTIFICATION'
